import { render, staticRenderFns } from "./CollapseDivFour.vue?vue&type=template&id=3795563e&"
import script from "./CollapseDivFour.vue?vue&type=script&lang=js&"
export * from "./CollapseDivFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports